module.exports = __webpack_public_path__ + "img/bangladesh@2x.d821fd01.png";